import { Page, ProgressBar, Banner, Modal, Link, Button, BlockStack, Text, Card, Bleed, Divider, InlineStack, FooterHelp, Icon, Box, Select, Checkbox, TextContainer } from '@shopify/polaris';
import React, { ReactElement, useContext, useEffect, useState, useRef } from 'react';
import { DI, DIProps } from '../../../../Core';
import { getallconnectedaccounts, getstepdeatails, savesellername, savesettingspreferences, savestepdetails, setsellerstatus } from '../onboardingApi';
import { CircleInformationMajor, ThumbsUpMinor } from '@shopify/polaris-icons';
import { clearSelectedStorage, initialOnboardingLoaders, newSellerModalRenderer, onboardingErrors, prepareChecklist } from './onboardinghelper';
import Stepone from './Stepone';
import Stepthree from './Stepthree';
import Steptwo from './Steptwo';
import { syncConnectorInfo, syncNecessaryInfo } from '../../../../Actions/NecessaryFun';
import { environment } from '../../../../environments/environment';
import { RenderSkeleton } from '../../Panel/index';
import { StoreDispatcher } from '../../../..';
import Reconnect from '../../../../Asests/Images/reconnect.png';
import { hasLength } from '../../Editproduct/utils/customHelperFunctions';
import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import '../css/styles.css';
import appLogo from '../images/appLogo.png';
import { status } from '../../Listing Grid/Utilities/Constants';
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../../Panel';
import { hasSelectedLanguage } from '../..';
import { IndicateIcon } from '../../../../Asests/svgIcon/icon'
import { saveConfigSourceOnly } from "../../index";

let socket: Socket<DefaultEventsMap, DefaultEventsMap>;


interface Props extends DIProps {
    syncConnectorInfo: (props: any, shop: any, updateCurrentShop?: boolean) => void;
    syncNecessaryInfo: (message: any) => void;
    updatePlanStatus: (status: string) => void;
    newAccount?: boolean;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
};

function Onboarding(props: Props): ReactElement {
    // Ref to track the last processed step
    const lastStepRef = useRef(null);
    const [confirmCheckbox, setConfirmCheckbox] = useState<boolean>(false)
    const { i18n, t } = useTranslation()
    const [activeModal, setModalActive] = useState<boolean>(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [loading, setLoading] = useState<any>(true);
    const [accountConnectionCheckLoader, setaccountConnectionCheckLoader] = useState(false)
    const [reverceAuthCheck, setReverceAuthCheck] = useState(false);
    // const [value, setValue] = useState<Array<string>>([]);
    const [states, setStates] = useState<any>({
        seller_type: undefined,
        seller: {
            manufacturer: {
                value: false,
                brand_name: ""
            },
            drop_shipper: {
                value: false,
            },
            retailer: {
                value: false,
            },
            reseller: {
                value: false
            },
            others: {
                value: false,
                other_type: ""
            }
        },
        selected_region: '',
        region: [],
        region_text: '',
        account_name: '',
        settings_preferences: {
            price: false,
            inventory: false,
            product_details: false,
            images: false
        },
        brand_registered: {
            value: "registered", // registered | not_registered
            reason: "",   // not_applied | pending_approval | willing_to_sell_generic
            brand_name: ''   // need exact brand name (case-sensitive)
        },
        fulfillment_settings: {
            FBM: {
                value: true,
                sku: true,
                barcode: false,
                priority: ["sku", "barcode"]
            },
            FBA: {
                value: false,
                sku: true,
                barcode: false,
                priority: ["sku", "barcode"]
            }
        },
        modal: {
            isOpen: false,
            title: '',
            data: []
        },
        isAccountConnected: false,
        account: {
            shopify: {},
            amazon: []
        },
        accont_connection_list: {
            primary_access_seller_account: false,
            seller_account_not_suspended: false,
            professional_account_with_payment_method: false,
            not_amazon_pay_account: false,
        },
        'steps_completed': 0,
        renderApp: true,
        previousUsedApp: '',
        previousUsedAppsValue: [],
        deactivateProduct: false
    });

    const [errors, setErrors] = useState<any>(onboardingErrors);
    const [alredySellingDisabled, setAlredySellingDisabled] = useState<boolean>(false);
    const [loaders, setLoaders] = useState<any>(initialOnboardingLoaders);
    const remoteShopId = props.di.globalState.get('remote_shop_id')
    const connectedSourcesData = JSON.parse(props.di.globalState.get('connected_sources') ?? '[]')

    const dispatcher = useContext(StoreDispatcher);

    function presenSourceInTarget(sources: any[], source_id: string) {
        let present = false;

        sources && sources.forEach((ele) => {
            if (ele?.shop_id == source_id) {
                present = true;
            }
        })

        return present;
    }

    // dont remove the code
    useEffect(() => {
        setReverceAuthCheck(true);
        props.di.POST("amazon/request/checkForAlredyInstalledShop", {
            shop: props?.redux?.current?.source?.domain,
            details: props?.redux?.current?.source
        }).then(data => {
            setReverceAuthCheck(false);
            if (data.success) {
                const shop = props.di.globalState.get(
                    `shop`
                );
                props.syncConnectorInfo(props, shop);
                props.syncNecessaryInfo({
                    connectAmazon: !props.newAccount, onboardingProps: props, source_shop_id: props?.redux?.current?.source?.['_id'] ?? ''
                    , target_shop_id: props?.redux?.current?.target?.['_id'] ?? ""
                });
            }

        })

        //     //Multi language modal
        //     if (props?.redux?.language) {
        //         setSelectedLanguage(props?.redux?.language ?? "en");
        //     }
        //     else {
        //         props.di.POST('connector/config/getConfig', {
        //             "group_code": ["language"]
        //         }).then((response: any) => {
        //             if (response?.success) {
        //                 if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
        //                     dispatcher({
        //                         type: 'update_language',
        //                         state: {
        //                             language: response?.data?.[0]?.value?.selectedLanguage ?? 'en',
        //                         },
        //                     });
        //                     props?.di?.globalState?.set('language', response?.data?.[0]?.value?.selectedLanguage ?? 'en');
        //                     i18n.changeLanguage(response?.data?.[0]?.value?.selectedLanguage ?? 'en');
        //                 }
        //                 else {
        //                     setModalActive(true);
        //                 }
        //             } else {
        //                 props.error(t(response.message));
        //             }
        //         });
        //     }
    }, []);

    // const initializeLanguage = async () => {
    //     try {
    //         const response = await props.di.POST('connector/config/getConfig', {
    //             group_code: ["language"]
    //         });

    //         if (response?.success) {
    //             const selectedLanguage =
    //                 response?.data?.[0]?.value?.selectedLanguage || "en";

    //             if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
    //                 dispatcher({
    //                     type: 'update_language',
    //                     state: { language: selectedLanguage },
    //                 });
    //                 props?.di?.globalState?.set('language', selectedLanguage);
    //                 i18n.changeLanguage(selectedLanguage);
    //             } else {
    //                 setModalActive(true); // Prompt user to select language
    //             }
    //         } else {
    //             props.error(t(response.message));
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch language config:", error);
    //         props.error(t("An error occurred while fetching language settings."));
    //     }
    // };

    // useEffect(() => {
    //     console.log("lastStepRef")
    //     // Run the effect only if the step has changed
    //     if (lastStepRef.current !== states['steps_completed']) {
    //         lastStepRef.current = states['steps_completed']; // Update the ref
    //         if (props?.redux?.language) {
    //             setSelectedLanguage(props.redux.language);
    //             // i18n.changeLanguage(props.redux.language);
    //         } else {
    //             initializeLanguage(); // Fetch language only if not already set
    //         }
    //     }
    // }, [states['steps_completed']]);

    const fetchConfigFromAPI = async (groupCode: string) => {
        const url = `${environment.API_ENDPOINT}connector/config/getConfig`;
        const requestHeaders = new Headers();
        const auth: any = props.di.globalState.getBearerToken();

        // Set headers
        requestHeaders.set('Authorization', auth);
        requestHeaders.set('appCode', "eyJzaG9waWZ5IjoiYW1hem9uX3NhbGVzX2NoYW5uZWwiLCJhbWF6b24iOiJhbWF6b24ifQ==");
        requestHeaders.set('appTag', "amazon_sales_channel");
        requestHeaders.set('Content-Security-Policy', "frame-ancestors https://admin.shopify.com");
        requestHeaders.set('Ced-Source-Id', props.di.globalState.get('source_id') ?? '');
        requestHeaders.set('Ced-Source-Name', "shopify");
        // requestHeaders.set('ced-target-name', "amazon");
        requestHeaders.set('Content-Type', 'application/json');

        const requestBody = JSON.stringify({ group_code: [groupCode] });

        try {
            const response = await fetch(url, {
                headers: requestHeaders,
                method: 'POST',
                body: requestBody,
            });
            const data = await response.json();

            if (data?.success) {
                return data;
            } else {
                throw new Error(data?.message || "API call failed.");
            }
        } catch (error) {
            // console.error("API Error:", error);
            // throw new Error("An error occurred while fetching data.");
        }
    };

    const initializeLanguage = async () => {
        try {
            const response = await fetchConfigFromAPI("language"); // Use the custom API function

            const selectedLanguage = response?.data?.[0]?.value?.selectedLanguage || "en";

            if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
                dispatcher({
                    type: 'update_language',
                    state: { language: selectedLanguage },
                });
                props?.di?.globalState?.set('language', selectedLanguage);
                i18n.changeLanguage(selectedLanguage);
            } else {
                setModalActive(true); // Prompt user to select language
            }
        } catch (error: any) {
            props.error(t(error.message || "An error occurred while fetching language settings."));
        }
    };


    useEffect(() => {
        // Run the effect only if the step has changed
        if (lastStepRef.current !== states['steps_completed']) {
            lastStepRef.current = states['steps_completed']; // Update the ref

            // Check if the language is already set
            if (props?.redux?.language) {
                setSelectedLanguage(props.redux.language);
                // i18n.changeLanguage(props.redux.language); // Ensure language is applied
            } else {
                initializeLanguage(); // Fetch language if not already set
            }
        }
    }, [states['steps_completed']]);


    async function getAllConnectedAccounts() {
        setLoading(true);
        let stopLoading = true;
        let { data, success } = await getallconnectedaccounts(props, {});

        states['settings_preferences'] = {
            price: false,
            inventory: false,
            product_details: false,
            images: false
        }

        let source_id: any = null;
        if (props?.redux?.current?.source?.marketplace == 'shopify') {
            source_id = props.redux.current.source['_id'];
        }
        if (success) {
            if (Object.keys(data).length > 0) {
                Object.keys(data).forEach(account => {
                    if (data?.[account]?.['marketplace'] === 'shopify' && data[account]['id'] == source_id) {
                        states['account']['shopify'] = data[account];
                        props.di.globalState.set('shopify_account', JSON.stringify(data[account]), true);
                    }
                    if (data?.[account]?.['marketplace'] === 'amazon' && presenSourceInTarget(data?.[account]?.['source'], source_id) && !props.newAccount) {
                        states['account']['amazon'] = [...states['account']['amazon'], data[account]];
                        states['account_name'] = data?.[account]?.['sellerName'] === null ? '' : data[account]['sellerName'];
                        stopLoading && getStepDetails('getConnectedAccounts');
                        stopLoading = false;
                        props.di.globalState.set('amazon_account', JSON.stringify(data[account]), true); //saved on local because saveChecklist api have to be called once the target is connected
                        prepareChecklist(JSON.parse(JSON.stringify(states)), props);
                    }
                })
            }
            stopLoading && setLoading(false);
            setStates({ ...states });
            clearSelectedStorage(props, ['account_checklist', 'amazon_account', 'shopify_account']);
        }
        else props.error(t('Something went wrong while connecting your account!'));
    }

    async function getStepDetails(str = '') {
        let { success, stepsCompleted, message, onboarding_completed } = await getstepdeatails(props);
        if (success) {
            if (stepsCompleted === 1) {
                states['steps_completed'] = parseInt(stepsCompleted);
                states['isAccountConnected'] = true;
                clearSelectedStorage(props, ['account_checklist', 'amazon_account', 'shopify_account']);
            }
            else if (stepsCompleted === null) {
                states['steps_completed'] = 0;
            }
            else {
                if (onboarding_completed || stepsCompleted === 3 + '') {
                    states['renderApp'] = true;
                    states['steps_completed'] = parseInt(stepsCompleted);
                }
                else states['steps_completed'] = parseInt(stepsCompleted);
            }
            setStates({ ...states });
        }
        else props.error(t(message));
        setLoading(false);
    }

    useEffect(() => {
        props.redux.current.source['_id'] && getAllConnectedAccounts();
    }, [props.redux.current.source['_id']]);

    function loaderHandler(field: string = '', subfield: string = '', value: boolean = false) {
        if (subfield != '') loaders[field][subfield] = value;
        else loaders[field] = value;
        setLoaders({ ...loaders });
    }

    function isLoading(): boolean | undefined {
        switch (states['steps_completed']) {
            case 0:
                return loaders['connectAmazonLoader'];
            case 1:
                return loaders['accountName'];
            case 2:
                return loaders['sellerType'];
            case 3:
                return loaders['settingPrefrences'];
            default:
                break;
        }
    }

    function updateState(field: string = '', subfield: string = '', metaField: string = '', value: any = '', actionHelper = () => { }) {
        if (metaField != '')
            states[field][subfield][metaField] = value
        else if (subfield != '')
            states[field][subfield] = value;
        else
            states[field] = value;
        setStates({ ...states });
        actionHelper(); //used to call helper function | side-effects
        errorHandler(field, false);
    }

    useEffect(() => {
        if (states.steps_completed === 0 || states.steps_completed === 1 || states.steps_completed === 2) return;
        if (states['renderApp'] && hasLength(props?.redux?.current?.target)) {
            if (!props.newAccount) {
                dispatcher({
                    type: 'onBoarding',
                    state: {
                        'step_status': '_COMPLETED_'
                    },
                });
            }
        } else {
            states['steps_completed'] = 0;
            setStates({ ...states });
        }
    }, [states, props?.redux?.current])

    function stepsRenderer() {
        if (states['steps_completed'] || states['steps_completed'] === 0) {
            switch (states['steps_completed']) {
                case 0:
                    return <Stepone
                        {...states}
                        errors={errors}
                        updateState={updateState}
                        isLoading={isLoading}
                        onSave={onSave}
                        getFooterActionText={getFooterActionText}
                    />

                case 1:
                    return <Steptwo
                        {...states}
                        errors={errors}
                        updateState={updateState}
                        isLoading={isLoading}
                        onSave={onSave}
                        getFooterActionText={getFooterActionText}
                    />
                case 2:
                    return <Stepthree
                        {...states}
                        errors={errors}
                        updateState={updateState}
                        alredySellingDisabled={alredySellingDisabled}
                        isLoading={isLoading}
                        onSave={onSave}
                        getFooterActionText={getFooterActionText}
                        errorHandler={errorHandler}
                        setAlredySellingDisabled={setAlredySellingDisabled}
                    />
                default:
                    return null;
            }
        }
        else return <></>
    }

    function errorHandler(type: string = '', value: boolean = false): void {

        if (errors?.[type] !== undefined) {
            errors[type] = value;
            setErrors({ ...errors });
        }
    }

    function validator() {
        let hasError = false;
        if (states['steps_completed'] === 0) {
            hasError = states['region'].length === 0 || states['region_text'].trim().length === 0 && states['region'].toString().length === 0
            hasError && errorHandler('region', true);
        }
        else if (states['steps_completed'] === 1) {
            hasError = states['account_name'] === '' || states['account_name'].trim().length === 0 || states['account_name']?.length > 32
            hasError && errorHandler('account_name', true);
        }
        else if (states['steps_completed'] === 2) {
            // hasError = states['seller_type'] === '';
            let err = true;
            // if (states['seller_type'] === '') {
            //     errorHandler('seller_type', true);
            // }
            Object.keys(states['seller']).forEach((key: string) => {
                if (states['seller'][key]['value']) {
                    err = false;
                }
            })

            if (states?.seller?.manufacturer?.value && !err)
                err = states.seller.manufacturer.brand_name.trim() === ''
            if (states?.seller?.others?.value && !err)
                err = states.seller.others.other_type.trim() === ''

            errorHandler('seller', err);
            if (err) hasError = true
            else hasError = false
            // let noneSelected = Object.values(states['product_settings']).every((element) => element === false);
            // if (noneSelected) {
            //     hasError = true;
            //     hasError && errorHandler('match_from_amazon', true);
            // }

            // if (states?.seller_type === 'existing_seller' && states?.previousUsedApp == 'yes') {
            //     hasError = states?.previousUsedAppsValue?.length ==0;
            //     hasError && errorHandler('previous_used_app', true);
            // }
            // if (states?.seller_type === 'existing_seller' && states?.previousUsedApp == 'yes') {
            //     hasError = states?.previousUsedAppsValue?.length ==0;
            //     hasError && errorHandler('previous_used_app', true);
            // }
            if (states?.seller_type === 'existing_seller' && states?.brand_registered?.value == 'registered') {
                hasError = states?.brand_registered?.brand_name?.trim() === "";
                hasError && errorHandler('registered_brand', true);
            }
            if (states?.seller_type === 'existing_seller' && states?.brand_registered?.value == 'not_registered') {
                hasError = states?.brand_registered?.reason?.trim() === ""
                hasError && errorHandler('not_registered_brand', true);
            }
            let noneSelected = states?.['seller_type'] !== "" && Object.values(states['fulfillment_settings']).every((element: any) => element?.value === false);
            if (noneSelected) {
                hasError = true;
                hasError && errorHandler('sync_status_fulfillment', true);
            }
            if (states?.seller_type === 'existing_seller' && states?.previousUsedApp == '') {
                hasError = states?.previousUsedApp == '';
                hasError && errorHandler('previous_used_app', true);
            }
            if (states?.seller_type === 'existing_seller' && states.previousUsedApp == 'yes' && states?.previousUsedAppsValue.length == 0) {
                hasError = states?.previousUsedAppsValue.length == 0;
                hasError && errorHandler('previous_used_app_value', true);
            }
            if (states?.seller_type === 'existing_seller' && states.deactivateProduct == '') {
                hasError = states?.deactivateProduct == "";
                hasError && errorHandler('deactivateProduct', true);
            }
        }
        return { hasError };
    }

    function onSave() {
        let { hasError } = validator();
        if (!hasError) {
            if (states['steps_completed'] === 0) {
                props.di.globalState.removeLocalStorage('remote_shop_id')
                socket = io('https://amazon.websocket.cedcommerce.com/', { path: '/onboarding.live', transports: ["websocket", "polling"] });;
                socket.on('connect', () => {
                    socket.emit("set_room", props.di.user_id + props?.redux?.current?.source?.['_id']);
                    socket.on('getRemoteShopID', (data: string) => {
                        props.di.globalState.set('remote_shop_id', data, true)
                    });
                })
                socket.on('disconnect', () => { })
                connectAmazon(socket);
                props.di.globalState.set('account_checklist', JSON.stringify(states?.['accont_connection_list']), true);
            }
            else if (states['steps_completed'] === 1) {
                saveSellerName();
            }
            else if (states['steps_completed'] === 2) {
                if (states['seller_type'] === 'new_seller')
                    modalHandler('new_seller', 'Attention', true);
                else setSellerType();
            }
            else if (states['steps_completed'] === 3) {
            }
        }
        else if (states['steps_completed'] === 3 && hasError) {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));
        } else {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));

        }
    }

    async function isPlanActive() {
        await props.di.GET('plan/plan/isPlanActive').then((e: any) => {
            if (e['success']) {
                props.di.globalState.set(`is_plan_active`, 'true');
                props.updatePlanStatus('_DONE_');
            } else {
                props.updatePlanStatus('_PENDING_');
            }
        });
    }

    async function saveSettingsPreferences() {
        loaderHandler('settingPrefrences', '', true);
        let tempStates = { ...states };
        const targetMarketplace = "amazon";
        const sourceMarketplace = "shopify";

        const shopIdAmazon = tempStates['account']?.['amazon']?.[0]?.['id'] ?? '';
        const shopIdShopify = tempStates['account']?.['shopify']?.['id'] ?? '';

        let { images, data, message } = await savesettingspreferences(props, {
            "target": { "marketplace": targetMarketplace, "shopId": shopIdAmazon },
            "source": { "marketplace": sourceMarketplace, "shopId": shopIdShopify },
            "settings_preferences": tempStates['settings_preferences']
        });

        if (data?.success || images.success) {
            const commonPayload = {
                "source": {
                    "shopId": props?.redux?.current?.source?.['_id'],
                    "marketplace": sourceMarketplace
                },
                "target": {
                    "shopId": props?.redux?.current?.target?.['_id'],
                    "marketplace": targetMarketplace
                }
            };

            const payloads = [
                {
                    "data": [
                        {
                            "group_code": "product",
                            "data": {
                                "sync_product_with": tempStates['fulfillment_settings'],
                                "seller": tempStates["seller"],
                                "brand_registered": tempStates['seller_type'] === 'existing_seller' ? tempStates['brand_registered'] : [],
                                "previousUsedApp": states?.previousUsedApp === "no" ? [] : states?.previousUsedAppsValue
                            }
                        }
                    ]
                },
                {
                    "data": [
                        {
                            "group_code": "inventory",
                            "data": {
                                "inactivate_product": tempStates['deactivateProduct'] == "deactivateProduct_yes" ? true : false
                            }
                        }
                    ]
                }
            ];

            try {
                const responses = await Promise.all(
                    payloads.map(payload =>
                        props.di.POST('connector/config/saveConfig', { ...payload, ...commonPayload })
                    )
                );

                if (responses.every(response => response?.success)) {
                    saveStepDetails(3);
                    getStepDetails('saveSettingsPreferences');
                    isPlanActive();
                } else {
                    loaderHandler('settingPrefrences', '', false);
                    props.error(t("Oops! Some error occured while saving settings."));
                }
            } catch (error) {
                loaderHandler('settingPrefrences', '', false);
                props.error(t("Oops! Some error occurred while saving settings."));
            }
        } else {
            props.error(t(message));
        }
    }

    // useEffect(() => {
    //     if (states['steps_completed'] === 3) {
    //         getStepDetails();
    //     }
    // }, [states]);

    async function setSellerType() {
        loaderHandler('sellerType', '', true);
        let tempStates = { ...states };
        let { success, data, message } = await setsellerstatus(props, {
            "target": { "marketplace": "amazon", "shopId": `${tempStates['account']?.['amazon']?.[0]?.['id'] ?? ''}` },
            "source": { "marketplace": "shopify", "shopId": `${tempStates['account']?.['shopify']?.['id'] ?? ''}` },
            sellerStatus: tempStates['seller_type']
        });
        if (success) {
            saveSettingsPreferences();
        }
        else props.error(t(message));
        loaderHandler('sellerType', '', false);
    }

    async function saveStepDetails(stepToupdate: number, str = '') {
        let tempStates = { ...states };
        let { data, success } = await savestepdetails(props, {
            "target": JSON.stringify({ "marketplace": "amazon", "shopId": `${tempStates['account']?.['amazon']?.[0]?.['id'] ?? ''}` }),
            "source": JSON.stringify({ "marketplace": "shopify", "shopId": `${tempStates['account']?.['shopify']?.['id'] ?? ''}` }),
            "app_tag": environment.appTag,
            "stepsCompleted": stepToupdate
        });
        if (success) {
            states['steps_completed'] = stepToupdate;
            setStates({ ...states });
        }
        else props.error(t('Error while saving steps!'));
        loaderHandler('settingPrefrences', '', false);
    }

    async function saveSellerName() {
        loaderHandler('accountName', '', true);
        const payload = {
            shopId: states['account']?.['amazon']?.[0]?.['id'],
            sellerName: states?.['account_name']
        }
        let { success, message } = await savesellername(props, { ...payload });
        if (success) {
            saveStepDetails(2, 'saveseller');
            const shop = props.di.globalState.get(`shop`);
            props.syncConnectorInfo(props, shop);
        }
        else props.error(t(message))
        loaderHandler('accountName', '', false);
    }

    function getFooterActionText(): any {
        if (states['steps_completed'] === 0)
            return t('Connect Amazon Account');
        else if (states['steps_completed'] === 2)
            return t("Complete Account Setup");
        else
            return "Next";
    }

    function renderConnectionBanner() {
        if (states['isAccountConnected'] && states['steps_completed'] === 1)
            return <Banner tone='success' title={t("Your account is successfully connected!")} icon={ThumbsUpMinor} ></Banner>;
    }

    function modalHandler(type: string = '', title: string = '', isOpen: boolean = false, data: any = {}) {
        states['modal']['title'] = title;
        states['modal']['isOpen'] = isOpen;
        states['modal']['data'] = data;
        states['modal']['type'] = type;
        setStates({ ...states });
    }

    function getConnectedSources(socket: any) {
        let id = props.di.globalState.get('remote_shop_id')
        socket.disconnect()
        if (!id || id === '') return;
        props.di.POST("amazon/request/getConnectedSource", { "remote_shop_id": id }).then((data) => {
            if (data?.success && Array.isArray(data?.data))
                props.di.globalState.set('connected_sources', JSON.stringify(data.data))
            else
                props.error(t(data?.message) ?? t("Couldn't find connected sources"))
        })
    }

    function connectAmazon(socket: any = '') {
        loaderHandler('connectAmazonLoader', '', true);
        let state = {
            "app_tag": props.di.environment.appTag,
            "user_id": props.di.user_id,
            "source": "shopify",
            "source_shop_id": props?.redux?.current?.source?.['_id'] ?? '',
            "redirect_return_type": "message"
        }
        let url = `${props.di.environment.API_ENDPOINT}connector/get/installationForm?code=${'amazon'}&region=${states.region[0]?.region}&version=new&sandbox=1&marketplace_id=${states.region[0]?.marketplace_id}&state=${JSON.stringify(state)}&bearer=${props.di.globalState.getBearerToken()}`;
        let test = window.open(url + '&redirect_return_type=message', 'popUpWindow', 'height=500,width=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');

        if (test) {
            const int = setInterval(() => {
                if (test?.closed) {
                    getConnectedSources(socket)
                    const shop = props.di.globalState.get(`shop`);
                    props.syncConnectorInfo(props, shop, props.newAccount);
                    props.syncNecessaryInfo({ connectAmazon: !props.newAccount, onboardingProps: props, source_shop_id: props?.redux?.current?.source?.['_id'] ?? '', target_shop_id: props?.redux?.current?.target?.['_id'] ?? "" });
                    if (!props.newAccount) {
                        getAllConnectedAccounts();
                    }
                    clearInterval(int);
                    loaderHandler('connectAmazonLoader', '', false);
                }
            }, 1000);
        }
        else {
            url = url + '&redirect_return_type=app';
            modalHandler('connectAmazon', 'Connect Amazon', true, url);
        }
        // if no
        // then open modal and add anhor tag <a/>
    }

    function getModalStructure() {
        let modalStructure: any = [];
        switch (states.modal.type) {
            case "new_seller":
                modalStructure.push(newSellerModalRenderer(t))
                break;
            case 'connectAmazon':
                modalStructure.push(<a href={states['modal']['data']} target='_self'>{t("Click to go to Amazon")}</a>)
                break;
            default:
                break;
        }
        return modalStructure;
    }

    if (loading || accountConnectionCheckLoader || reverceAuthCheck) {
        return <RenderSkeleton {...props} />
    }

    function connectedSources() {
        return connectedSourcesData.length > 0 && connectedSourcesData.map((ele: any) => <li>{ele}</li>)
    }

    if (props.redux.step_status == '_FAILED_') {
        if (remoteShopId) {
            return (
                <BlockStack gap="800">
                    <Banner tone="critical">
                        <Text as='p' tone="subdued">{t("Your account connection was unsuccessful.")}</Text>
                    </Banner>
                    <Card roundedAbove='sm'>
                        <BlockStack gap="400">
                            <Text as='h2' variant='headingMd'>{t("What could have possibly went wrong!!")}</Text>
                            <InlineStack gap="400" align='space-between'>
                                <BlockStack gap="400">
                                    <div style={{ maxWidth: "612px" }}>
                                        <BlockStack gap="200">
                                            <Text as='p'>
                                                {t("We're sorry to inform you that you cannot connect the same Amazon account with multiple users. It looks like the account is already connected with:")}
                                            </Text>
                                            {connectedSources()}
                                            <Text as='p'>
                                                {t("To reconnect, you will need to first disconnect the Amazon account from previous store(s) and then wait for 48 hours before connecting it again to another store.")} <br />
                                                {t("For instant help connect with our")} <Button onClick={() => props.history('/panel/user/support')} variant="plain">{t("support team.")}</Button>
                                            </Text>
                                        </BlockStack>
                                    </div>
                                    <div>
                                        <Button
                                            onClick={() => {
                                                setStates({ ...states, region: [], region_text: '' })
                                                dispatcher({ type: 'onBoarding', state: { 'step_status': '_INPROGRESS_' } });
                                            }}
                                            variant="primary">
                                            {t("Retry Connecting")}
                                        </Button>
                                    </div>
                                </BlockStack>
                                <img src={Reconnect} />
                            </InlineStack>
                        </BlockStack>
                    </Card>
                </BlockStack>
            );
        }
        return (
            <BlockStack gap="800">
                <Banner tone="critical">
                    <Text as='p' tone="subdued">{t("Your account connection was unsuccessful.")}</Text>
                </Banner>
                <Card roundedAbove='sm'>
                    <BlockStack gap="400">
                        <Text as='h2' variant='headingMd'>{t("Wondering what could have gone wrong?")}</Text>
                        <InlineStack gap="400">
                            <div className='Custom-Stack-Item--fill'>
                                <BlockStack gap="500">
                                    <BlockStack gap="200">
                                        <BlockStack gap="100">
                                            <Text as='p' tone='subdued'>1. {t("You currently do not have Primary Access to the Amazon Seller Central Account.")}</Text>
                                            <Text as='p' tone='subdued'>2. {t("You are trying to log in using an Amazon Pay account.")}</Text>
                                            <Text as='p' tone='subdued'>3. {t("Your Seller Account is either Suspended, Inactive, or in Vacation mode.")}</Text>
                                            <Text as='p' tone='subdued'>4. {t("You don't have an Amazon Professional Account.")}</Text>
                                        </BlockStack>
                                        <Link target='_blank' removeUnderline={true} url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=onboarding-the-app-4">{t("For more information, click here.")}</Link>
                                    </BlockStack>
                                    <div>
                                        <Button
                                            onClick={() => {
                                                setStates({ ...states, region: [], region_text: '' })
                                                dispatcher({ type: 'onBoarding', state: { 'step_status': '_INPROGRESS_' } });
                                            }}
                                            variant="primary">
                                            {t("Retry Connecting")}
                                        </Button>
                                    </div>
                                </BlockStack>
                            </div>
                            <img src={Reconnect} />
                        </InlineStack>
                    </BlockStack>
                </Card>
            </BlockStack>
        );
    }

    const renderBreadcrumbs = Object.values(props.match).includes('newAccount') && states?.['steps_completed'] === 0;

    const handleClose = async () => {
        // props.di.POST('connector/config/saveConfig', {
        //     "data": [
        //         {
        //             "data": {
        //                 selectedLanguage: "en"
        //             },
        //             "group_code": "language"
        //         }
        //     ]
        // }).then((response: any) => {
        //     if (response.success) {
        //         i18n.changeLanguage("en");
        //         props.di.globalState.set('language', "en");
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: "en",
        //             },
        //         });
        //     } else {
        //         props.error(t(response.message))
        //     }
        //     setModalActive(false);
        // });

        let response = await saveConfigSourceOnly("language", "en", props);
        if (response.success) {
            i18n.changeLanguage("en");
            props.di.globalState.set('language', "en");
            dispatcher({
                type: 'update_language',
                state: {
                    language: "en",
                },
            });
        } else {
            props.error(t(response.message))
        }
        setModalActive(false);
    }

    const handleLanguageChange = async () => {
        // props.di.POST('connector/config/saveConfig', {
        //     "data": [
        //         {
        //             "data": {
        //                 selectedLanguage: selectedLanguage
        //             },
        //             "group_code": "language"
        //         }
        //     ]
        // }).then((response: any) => {
        //     if (response.success) {
        //         i18n.changeLanguage(selectedLanguage);
        //         props.di.globalState.set('language', selectedLanguage);
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: selectedLanguage ?? 'en',
        //             },
        //         });
        //     } else {
        //         props.error(t(response.message))
        //     }
        //     setModalActive(false);
        // });

        let response = await saveConfigSourceOnly("language", selectedLanguage, props);
        if (response.success) {
            i18n.changeLanguage(selectedLanguage);
            props.di.globalState.set('language', selectedLanguage);
            dispatcher({
                type: 'update_language',
                state: {
                    language: selectedLanguage ?? 'en',
                },
            });
        } else {
            props.error(t(response.message))
        }
        setModalActive(false);
    }

    const languages = [
        { label: 'English (Default)', value: 'en' },
        { label: 'हिंदी', value: 'hn' },
        { label: 'Deutsch', value: 'gr' },
        { label: 'Français', value: 'fr' },
        // { label: 'Português', value: 'pr' },
        { label: 'Español', value: 'sp' },
        // { label: 'العربية', value: 'ar' },
        // { label: 'Nederlands', value: 'du' },
        // { label: 'Italiano', value: 'it' },
        // { label: 'Polski', value: 'po' },
        // { label: 'Svenska', value: 'sw' },
        // { label: 'Türkçe', value: 'tr' },
        // { label: '日本語', value: 'jp' },
        // { label: 'Afrikaans', value: 'af' },
    ];

    return (
        <Page
            title={renderBreadcrumbs ? t('Add New Account') : undefined}
            backAction={renderBreadcrumbs ? { content: t("Template"), onAction: () => { props.history(-1) } } : undefined}
            primaryAction={
                <RenderHeadersAction {...props} show_only_lng_switcher />
            }
        >
            <Modal
                open={activeModal}
                onClose={() => { }}
                title={t("Preferred Language of the App")}
            >
                <Modal.Section>
                    <BlockStack gap="200">
                        <Text as="p" variant="bodyMd">
                            {t("Before getting started, please select the preferred language for the app")}
                        </Text>
                        <Select
                            label=""
                            labelHidden
                            options={languages}
                            onChange={(e) => setSelectedLanguage(e)}
                            value={selectedLanguage}
                        />
                        {<div className='Custom__Sync--Update'>
                            <Checkbox
                                // disabled={selectedLanguage === "en"}
                                checked={confirmCheckbox}
                                onChange={(e) => setConfirmCheckbox(e)}
                                label={<Text variant="bodySm" tone="subdued" as="p">
                                    {t("You have chosen")} <Text as="span" fontWeight="bold">{languages.filter((language: any) => language.value == selectedLanguage)?.[0]?.label}</Text> {t("as your preferred language. You can change it later in the Settings section.")}
                                </Text>}
                            />
                        </div>}
                        <Button
                            variant='primary'
                            disabled={!confirmCheckbox}
                            onClick={handleLanguageChange}
                        >
                            {t("Click to Proceed")}
                        </Button>
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <BlockStack gap="600">
                {renderConnectionBanner()}
                <BlockStack gap="500">
                    <div className='mobile-spacing'>
                        <BlockStack gap="100">
                            <Text variant="headingLg" as="p">{t("CedCommerce Amazon Channel")}</Text>
                            <Text as='p'> {t("Seamlessly connect your online store with Amazon marketplace using our powerful integration tool. Effortlessly manage inventory, streamline order fulfilment, and optimize sales operations for multiple Amazon accounts, unlocking your full potential on Amazon.")}</Text>
                        </BlockStack>
                    </div>
                    <div className="onboardnig-section">
                        <Card roundedAbove='sm'>
                            <BlockStack gap="400">
                                <Bleed marginInline="400" marginBlockStart='400'>
                                    <div className='custom-progress'>
                                        <ProgressBar size='small' progress={((states['steps_completed'] >= 3 ? 3 : states['steps_completed']) / 3) * 100} tone="success" />
                                    </div>
                                </Bleed>
                                <BlockStack gap="500">
                                    <InlineStack gap="300">
                                        <img src={appLogo} width={20} alt="logo" className="border-radius50" />
                                        <Text as="span" tone="subdued" fontWeight="semibold">{t("ACCOUNT CREATION")}</Text>
                                    </InlineStack>
                                    {stepsRenderer()}
                                </BlockStack>
                                <Divider />
                                {
                                    states['steps_completed'] === 0 &&
                                    <Box paddingBlockStart="500">
                                        <InlineStack gap="100" align='center'>
                                            <Text as='p'>{t("Don't have an Amazon account?")}</Text>
                                            <Link url='https://cedcommerce.com/marketplace-integration/sell-on-amazon' target='_blank'>{t("Create Amazon Seller Central Seller Account")}</Link>
                                        </InlineStack>
                                    </Box>
                                }
                            </BlockStack>
                        </Card>
                    </div>
                </BlockStack>
            </BlockStack>
            <Modal
                open={states['modal']['isOpen']}
                title={t(states.modal['title'])}
                onClose={function (): void { modalHandler('', '', false) }}
                primaryAction={{
                    content: t('Ok, I understand'),
                    onAction: () => {
                        setSellerType();
                        modalHandler(states.modal.type, '', false);
                    }
                }}
            >
                <Modal.Section>
                    {getModalStructure()}
                </Modal.Section>
            </Modal>

            <FooterHelp>
                <InlineStack align="center" gap="100">
                    <div><Icon source={CircleInformationMajor} tone="info" /></div>
                    {t("Learn more about")}
                    <Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/onboarding-the-app">
                        {t("CedCommerce Amazon Channel")},
                    </Link>
                    <Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                        {t("Terms & Conditions")}
                    </Link>
                    {t("and")}
                    <Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                        {t("Data Privacy Rights.")}
                    </Link>
                    {t("Need Help?")}
                    <Link onClick={() => props.di.globalState.get('onboarding_completed') ? props.history('../../panel/user/support') : props.history('../../panel/support')}>
                        {t("Get Support")}
                    </Link>
                    {t("or")}
                    <Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                        {t("Book a Call")}
                    </Link>
                </InlineStack>
            </FooterHelp>
        </Page >
    );
}

export default DI(Onboarding, { func: { syncConnectorInfo, syncNecessaryInfo } });